export enum FlowType {
  SMILE_SIMULATION = "SMILE_SIMULATION",
  SMILE_ASSESSMENT = "SMILE_ASSESSMENT",
  FULL_ASSESSMENT = "FULL_ASSESSMENT",
}

export default FlowType;
